import {Component, OnInit} from '@angular/core';
import {FilterModel, LeModalService, Page, UsersQuery} from "common-shared";
import {TableComponent} from "common-shared";
import {EventFilterModel, EventModel, EventService} from "./event.service";
import {BehaviorSubject, Observable} from "rxjs";
import {EventViewModalComponent} from "../event-view/event-view-modal.component";
import {map} from "rxjs/operators";

@Component({
  selector: 'app-event-list',
  templateUrl: './event-list.component.html',
  styles: [
  ]
})
export class EventListComponent extends TableComponent implements OnInit {
  filter$: BehaviorSubject<FilterModel<EventFilterModel>> = new BehaviorSubject<FilterModel<EventFilterModel>>(new FilterModel<EventFilterModel>({}));
  filteredData$: Observable<EventModel[]>;
  page = new Page({Size: 50});
  loading: boolean = true;

  constructor(public eventService: EventService, public usersQuery: UsersQuery, private leModalService: LeModalService) {
    super();
  }

  ngOnInit(): void {
    const state = localStorage.getItem('event-list-local');
    if (state) {
      const stateObject = JSON.parse(state);
      this.page.Size = stateObject.rows;
      this.page.Number = stateObject.first / stateObject.rows;
    }

    this.setPage();
  }

  setPage() {
    this.loading = true;
    let filter = this.filter$.getValue();
    filter.Page = this.page;

    this.filteredData$ = this.eventService.getByFilter(filter).pipe(map(pagedData => {
      this.page = pagedData.Page;
      this.loading = false;
      return pagedData.Data;
    }));
  }

  onPage(event: any) {
    this.page.Number = event.first / event.rows;
    this.page.Size = event.rows;
    const filter = this.filter$.getValue();
    filter.Page = this.page;
    this.setPage();
  }

  open(row: any) {
    this.eventService.loadOne(row.Id).subscribe(value => {
      this.leModalService.show(EventViewModalComponent, {initialState: {event: value}, class: 'modal-lg'});
    });
  }

  onFilter($event: any) {
    this.setPage();
  }
}
